import Vue from 'vue';
import Editor from 'primevue/editor';

Vue.component('Editor', Editor);
